var map = {
	"./Dashboard.png": [
		19099,
		99
	],
	"./Data Analysis.png": [
		73369,
		369
	],
	"./Data Growth Statistics.png": [
		7337,
		337
	],
	"./Instructions.png": [
		53692,
		692
	],
	"./Presentation.png": [
		83127,
		127
	],
	"./Solar Panel.png": [
		60110,
		110
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 94332;
module.exports = webpackAsyncContext;